export default {

  init() {

    this.closeModalOnEsc = this.closeModalOnEsc.bind( this );

    $( document ).on( 'click', '[data-modal]', this.triggerFormModal );
    $( document ).on( 'click', '[data-modal_el] [type="reset"]', this.closeModal );
    $( document ).on( 'click', '[data-close-modal]', this.closeModal );
    $( document ).on( 'click', '.js-close-modal', this.closeModal );
    $( document ).on( 'keyup', this.closeModalOnEsc );

  },

  triggerFormModal( event ) {

    if ( document.body.classList.contains( 'modal-open' ) ) {
      document.body.classList.remove( 'modal-open' );
      $( '.modal.is-open' ).fadeOut();
    } else {
      document.body.classList.add( 'modal-open' );
      const modal = event.currentTarget.dataset.modal;
      $( '[data-modal_el="' + modal + '"]' ).fadeIn();
    }

  },

  closeModalOnEsc( event ) {

    if ( document.body.classList.contains( 'modal-open' ) ) {
      if ( event.keyCode === 27 ) { // escape key maps to keycode `27`
        this.closeModal();
      }
    }

  },

  closeModal() {

    $( '[data-modal_el]' ).fadeOut();
    document.body.classList.remove( 'modal-open' );

    if ( $( '[data-modal_el]' ).find( 'iframe' ).length > 0 ) {
      $( '[data-modal_el]' ).find( 'iframe' ).remove();
    }

  },

}



// WEBPACK FOOTER //
// ./scripts/modules/modal.js